
import { Component, Vue, Prop } from 'vue-property-decorator'; 
import moment from 'moment-timezone';
import { affidavitInfoType } from '@/types/Information/Form4';

@Component
export default class AddAffidavitForm extends Vue {        

    @Prop({required: true})
    formData!: affidavitInfoType;

    @Prop({required: true})
    index!: number;

    @Prop({required: true})
    isCreateAffidavit!: boolean;    
    
    name = '';
    nameState = true;

    date = '';
    dateState = true;
    
    originalName = ''; 
    originalDate = '';    
    
    showCancelWarning = false;

    addButtonText = 'Add';
    dataReady = false;
    
    mounted()
    { 
        this.dataReady = false;
        this.clearSelections();
        if(!this.isCreateAffidavit) {
            this.extractFormInfo();
            this.addButtonText = 'Save';
        } else {
            this.addButtonText = 'Add';
        }
        
        this.dataReady = true;              
    }

    public extractFormInfo(){
        this.originalName = this.name = this.formData.name;
        this.originalDate = this.date = this.formData.date;           
    }

    public saveForm(){
            
        this.nameState = this.name != "";
        this.dateState = this.date != "";        
        
        if (this.nameState && this.dateState){        
            const affidavitInfo = {} as affidavitInfoType;            
            affidavitInfo.name = this.name;    
            affidavitInfo.date = this.date;
            
            this.$emit('submit', this.isCreateAffidavit, affidavitInfo, this.index);
        }            
    }

    public closeForm(){
        if(this.isChanged())
            this.showCancelWarning = true;
        else
            this.confirmedCloseForm();
    }

    public isChanged(){
        if(this.isCreateAffidavit){
            if(this.name.length && this.date.length) return true;
            return false;
        } else {

            if ( this.originalName != this.name || 
                this.originalDate != this.date ) {
                    return true;
                } else {
                    return false;
                }                
        }
    }

    public confirmedCloseForm(){           
        this.clearSelections();
        this.$emit('cancel');
    }

    public clearSelections(){
        this.name = '';
        this.nameState = true; 
        
        this.date = '';
        this.dateState = true;
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date <= day);           
    }
    
}
